import {UIElement} from "./ui";
import '/modules/common/css/ui/dropdown.css';
import '/modules/common/css/ui/dropdown.mobile.css';
import {nnTrim} from "../util";

/**
 * A dropdown element implemented with a select HTML element
 * @extends UIElement
 */
class Dropdown extends UIElement {

    getClassName() {
        return "Dropdown";
    }

    /**
     *
     * @param id {string} Dropdown id
     * @param dropDownOptions {Array<DropdownOption>} A list of options for this dropdown
     * @param initialValue {string} The initial value for this dropdown
     * @param mandatory {boolean} Is this dropdown mandatory?
     * @param emptyLabelKey {string} if not mandatory, this will be the label of the empty option
     * @param onChange {function} A callback to be called when the value changes
     * @param parentDropdown {Dropdown} If not undefined, only the options with the parentValue corresponding matching the current parentDropdown value will be available for the user to choose
     * @param allowEmptyParentValue {boolean} If true, allows showing all options if parent dropdown has no option selected
     */
    constructor(id, dropDownOptions, initialValue=undefined, mandatory, emptyLabelKey=undefined, onChange=undefined, parentDropdown = undefined, allowEmptyParentValue = false) {
        super(id, undefined);
        this.id = id;
        this.value = initialValue;
        this.dropDownOptions = dropDownOptions.slice();
        this.mandatory = mandatory;
        this.emptyLabelKey = emptyLabelKey;
        this.emptyValue = tumbo.translator.translate(emptyLabelKey);
        this.parentDropdown = parentDropdown;
        this.allowEmptyParentValue = allowEmptyParentValue;

        if (this.parentDropdown) {
            this.parentValue = this.parentDropdown.getValue();
        }
        this.onChangeCallbacks = new Set();
        this.onChange(onChange);

        if (this.parentDropdown) {
            this.parentDropdown.onChange(parent => this._onChangeParentDropdown(parent));
        }
    }

    disableUI() {
        $('#' + this.id + '_select', this.getUIElement()).addClass('disabled').attr('disabled', 'disabled');
        return this;
    }

    enableUI() {
        $('#' + this.id + '_select', this.getUIElement()).removeClass('disabled').removeAttr('disabled');
        return this;
    }

    getCode() {
        return this.id;
    }

    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $(
                '<div id="' + this.id + '" class="dropdown-input">' +
                '   <select id="' + this.id + '_select"></select><span></span>' +
                '</div>'
            );
            this._setOptions();

            let self = this;
            $('select', this.uiElement).change(function () {
                self._setValue($(this).val(), true);
                self.logStat("CHANGE {" + $(this).val() + "}")
            });
            $('span', this.uiElement).click(function () {
                $('select', self.uiElement).show();
            });
        }
        return this.uiElement;
    }

    _setOptions(triggerOnChange = false) {
        const {options, selectedOption} = this._getOptions(triggerOnChange);
        const select = $('select', this.uiElement).empty();
        options.map(o => o.getUIElement()).forEach(oElem => select.append(oElem));
        if (selectedOption) {
            this._setValue(this.value, triggerOnChange);
        } else if (this.mandatory && options.length > 0) {
            this._setValue(options[0].getValue(), triggerOnChange);
        }
    }

    _getOptions(triggerOnChange) {
        const options = [];
        for (let o in this.dropDownOptions) {
            if (this.parentDropdown) {
                if ((this.allowEmptyParentValue && !this.parentValue) || !this.dropDownOptions[o]._getParentValue()
                    || this.dropDownOptions[o]._getParentValue() === this.parentValue)
                    options.push(this.dropDownOptions[o]);
            } else options.push(this.dropDownOptions[o]);
        }
        if (options.length === 0)
            this.disableUI();
        else this.enableUI();

        const selectedOption = options.filter(o => o.getValue() === this.value)[0];
        if (!this.mandatory) {
            const emptyOption = new DropdownOption(this.emptyLabelKey, undefined);
            options.unshift(emptyOption);
            if (!selectedOption) {
                emptyOption._select();
                if (triggerOnChange) {
                    this._setValue(undefined, triggerOnChange);
                }
            }
        }
        return {options, selectedOption};
    }

    /**
     * Get this dropdown options array
     * @return {Array<DropdownOption>}
     */
    getOptions() {
        return this.dropDownOptions;
    }

    onChange(callback) {
        if (callback) {
            this.onChangeCallbacks.add(callback);
        }
        return this;
    }

    /**
     * Get this dropdown current value
     * @return {string}
     */
    getValue() {
        const option = nnTrim(this.value) ? this.getOptions().filter(o => !o.isDisabled() && o.getValue() === this.value)[0] : undefined;
        return option ? option.getValue() : undefined;
    }

    /**
     * Set the value for this drop down
     * @param value {string}
     * @param ignoreChangeTriggers {boolean} if true, ignores the on change triggers
     */
    setValue(value, ignoreChangeTriggers=false) {
        this._setValue(value, !ignoreChangeTriggers);
    }

    _setValue(value, triggerOnChange = false) {
        const initialValue = this.value;
        const select = $('select', this.getUIElement());
        if (value === undefined || value === this.emptyValue) {
            if (this.mandatory) {
                const firstOption = this.dropDownOptions.filter(o =>
                    !o.isDisabled() && ((o._getParentValue() === undefined && this.parentValue === undefined) || o._getParentValue() === this.parentValue)
                )[0];
                if (firstOption) {
                    this.value = firstOption.getValue();
                    select.val(firstOption.getValue());
                }
            } else {
                select[0].selectedIndex = 0;
                this.value = undefined;
            }
        } else {
            const option = this.dropDownOptions.filter(o =>
                !o.isDisabled() && ((!this.parentValue || o._getParentValue() === this.parentValue) && o.getValue() === value)
            )[0];
            if (option) {
                this.value = option.getValue();
                option._select();
            }
        }
        if (triggerOnChange && this.value !== initialValue) {
            this.onChangeCallbacks.forEach(c => c(this));
        }
    }

    _onChangeParentDropdown(parent) {
        if (parent.getValue() !== this.parentValue) {
            this.parentValue = parent.getValue();
            this._setOptions(true);
        }
    }
}


/**
 * A dropdown element just like the Dropdown but chunkier, to match the style of SearchableDropdown
 * @extends Dropdown
 * @hideconstructor
 */
class ChunkyDropdown extends Dropdown {

    getClassName() {
        return "ChunkyDropdown";
    }

    getUIElement() {
        if (!this.uiElement) {
            return super.getUIElement().addClass('chunky');
        }
        return super.getUIElement();
    }
}


/**
 * A dropdown option
 * @extends UIElement
 */
class DropdownOption extends UIElement {

    getClassName() {
        return "DropdownOption";
    }

    /**
     *
     * @param labelKey {string} A localization key for this option's label
     * @param value {string} The value
     * @param parentValue {string} The parent value. If undefined, the option will show independently of the parent
     * @param disabled {boolean} if true presents the option as not selectable
     */
    constructor(labelKey, value, parentValue = undefined, disabled = false) {
        super(labelKey, undefined, undefined);
        this.labelKey = labelKey;
        this.value = value;
        this.parentValue = parentValue;
        this.disabled = disabled;
    }

    /**
     * update this option label
     * @param labelKey {string}
     */
    setLabelKey(labelKey) {
        this.labelKey = labelKey;
        this.getUIElement().html(tumbo.translator.translate(this.labelKey));
    }

    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $('<option>' + tumbo.translator.translate(this.labelKey) + '</option>');
            if (this.value) {
                this.uiElement.attr('value', this.value);
            }
            if (this.disabled) {
                this.uiElement.attr('disabled', 'disabled').addClass('disabled');
            }
        }
        return this.uiElement;
    }

    _select() {
        $('option', $(this.getUIElement().parents('select')[0])).removeAttr('selected');
        this.getUIElement().attr('selected', '');
        $(this.getUIElement().parents('select')[0]).val(this.value);
    }

    isSelected() {
        return !!this.getUIElement().attr('selected');
    }

    isDisabled() {
        return this.disabled;
    }

    /**
     * This option's value
     * @return {string}
     */
    getValue() {
        return this.value;
    }

    getName() {
        return tumbo.translator.translate(this.labelKey);
    }

    _getParentValue() {
        return this.parentValue;
    }

    disable() {
        this.getUIElement().attr('disabled', 'disabled').addClass('disabled');
    }

    enable() {
        this.getUIElement().removeAttr('disabled').removeClass('disabled');
    }

}

export {Dropdown, ChunkyDropdown, DropdownOption}